import styled from '@emotion/styled';
import { Backdrop } from '@mui/material';

export default styled(Backdrop)`
  ${(props) => {
    const { theme } = props;

    return `
            z-index: ${theme.zIndex.tooltip};
        `;
  }}
`;
